import { Document } from '../../models/document/document.model';

export class DocumentListResponse {
    document: Document[];
    constructor(document: Document[]) {
        this.document = document;
    }
}
